import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "../../Components/Grid/Grid";
import Modal from "../../Components/Modal/AdminRequest/Modal";
import Button from "../../Components/button/button";
import "../../Style/IncidentView.css";
import config from "../../config";
import getColumnDefs from "../../utils/AdminRequest/adminRequestcolumnDefs";
import { AdminRequestData } from "../../utils/AdminRequest/adminRequestTypes";
import { formatDuration } from "../../utils/durationUtils";
import { authFetch } from "../../utils/Security/authFetch";
import { GridApi } from "ag-grid-community";
import localforage from "localforage";

const CACHE_KEY = "incident_cache";
const AdminRequestView: React.FC = () => {
  const userId = localStorage.getItem("userid");
  const isemployee = localStorage.getItem("isemployee") === "true";
  const ismanager = localStorage.getItem("ismanager") === "true";

  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const [rowData, setRowData] = useState<AdminRequestData[]>([]);
  const [filteredData, setFilteredData] = useState<AdminRequestData[]>([]);
  const [selectedAdminRequest, setSelectedAdminRequest] =
    useState<AdminRequestData | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const isForTelebras = localStorage.getItem("isForTelebras") === "true";
  const isForPetrobras = localStorage.getItem("isForPetrobras") === "true";
  const handleEdit = (data: AdminRequestData) => {
    navigate(`/adminRequest-edit/${data.ticketId}`, {
      state: { adminRequest: data },
    });
  };

  const handleDelete = async (ticketId: string) => {
    if (!window.confirm("Are you sure you want to delete this Request?"))
      return;

    try {
      const response = await authFetch(
        `${config.apiBaseUrl}/api/adminRequests/${ticketId}`,
        {
          method: "DELETE",
        }
      );

      if (response.ok) {
        const updatedData = rowData.filter(
          (adminRequest) => adminRequest.ticketId !== ticketId
        );
        setRowData(updatedData);
        setFilteredData(updatedData.filter(applySearchFilter));
      } else {
        console.error("Failed to delete adminRequest");
      }
    } catch (error) {
      console.error("Error deleting adminRequest:", error);
    }
  };

  useEffect(() => {
    localforage.removeItem(CACHE_KEY);
    const fetchAdminRequests = async () => {
      try {
        const url = `${config.apiBaseUrl}/api/adminRequests/user/${userId}`;

        const response = await authFetch(url);
        if (response.ok) {
          const data: AdminRequestData[] = await response.json();

          const foadminRequesttted = data.map((item) => ({
            ...item,
          }));
   if (isAdmin && (isForTelebras || isForPetrobras)) {
      setRowData([]);
      setFilteredData([]);
      return;
    }
          setRowData(foadminRequesttted);
          setFilteredData(foadminRequesttted);
        } else {
          console.error("Failed to fetch adminRequests");
        }
      } catch (error) {
        console.error("Error fetching adminRequests:", error);
      }
    };

    fetchAdminRequests();
  }, [isAdmin, userId]);

  const columnDefs = getColumnDefs(handleEdit, handleDelete);

  const handleRowClick = (data: AdminRequestData) => {
    setSelectedAdminRequest(data);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedAdminRequest(null);
  };

  const gridApiRef = useRef<GridApi | null>(null);
  const stripHtml = (html: string): string => {
    const div = document.createElement("div");

    const htmlWithImagePlaceholder = html.replace(/<img[^>]*>/gi, "[Image]");

    div.innerHTML = htmlWithImagePlaceholder;
    return div.textContent || div.innerText || "";
  };
  const handleExportCSV = () => {
    if (!gridApiRef.current) {
      alert("Grid is not ready.");
      return;
    }

    const filteredNodes: AdminRequestData[] = [];
    gridApiRef.current.forEachNodeAfterFilter((node) => {
      if (node.data) {
        filteredNodes.push(node.data);
      }
    });

    if (!filteredNodes.length) {
      alert("No data to export.");
      return;
    }

    const exportableColumns = columnDefs.filter((col) => !!col.field);
    const headers = exportableColumns.map((col) => col.headerName || col.field);
    const fields = exportableColumns.map(
      (col) => col.field as keyof AdminRequestData
    );

    const sanitizeField = (value: any, field: string): string => {
      if (typeof value !== "string") return String(value ?? "");
      if (["summary", "description", "solution"].includes(field)) {
        return stripHtml(value);
      }
      if (/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
        return value.replace("T", " ");
      }
      return value;
    };

    const csvRows = [
      headers.join(","),
      ...filteredNodes.map((row) =>
        fields
          .map((field) => JSON.stringify(sanitizeField(row[field], field)))
          .join(",")
      ),
    ];

    const blob = new Blob(["﻿" + csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "AdminRequestData.csv";
    a.click();
    URL.revokeObjectURL(url);
  };
  const applySearchFilter = (item: AdminRequestData): boolean => {
    const query = searchQuery.toLowerCase();
    return Object.values(item).some(
      (value) =>
        value !== null &&
        value !== undefined &&
        value.toString().toLowerCase().includes(query)
    );
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchQuery(value);
    setFilteredData(rowData.filter(applySearchFilter));
  };

  return (
    <>
      <div className="top">
        <div className="add">
          <div className="right-section">
    { !isForTelebras && !isForPetrobras &&(
            <Button
              variant="primary"
              size="md"
              onClick={() => navigate("/adminRequest-add")}
            >
              + Add
            </Button>
)}
            <Button variant="primary" size="md" onClick={handleExportCSV}>
              Export to CSV
            </Button>
            <input
              type="text"
              placeholder="Full Search..."
              value={searchQuery}
              onChange={handleSearchChange}
              style={{
                padding: "8px",
                borderRadius: "5px",
                border: "1px solid gray",
                width: "400px",
              }}
            />
          </div>
        </div>
      </div>

      <div className="Grid" style={{ height: "82%" }}>
        <Grid<AdminRequestData>
          rowData={filteredData}
          columnDefs={columnDefs}
          onGridReady={(params: { api: GridApi<any> | null }) => {
            gridApiRef.current = params.api;
          }}
          onRowClick={handleRowClick}
        />
      </div>

      <Modal
        isOpen={isModalOpen}
        data={selectedAdminRequest}
        onClose={closeModal}
      />
    </>
  );
};

export default AdminRequestView;
